<template>
  <v-snackbar
    v-model="isNotification"
    :color="notificationType"
    :multi-line="true"
    :auto-height="true">
    <p
      v-for="(alert, index) in notificationTextArr"
      :key="index">{{ alert }}</p>
    <v-btn
      dark
      flat
      @click="isNotification = false">
      {{ $t('close') }}
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'GlobalNotifications',
  computed: {
    ...mapFields('notification', ['isNotification', 'notificationTextArr', 'notificationType'])
  },
  i18n: {
    messages: {
      en: {
        close: 'Close'
      },
      tr: {
        close: 'Kapat'
      },
      de: {
        close: 'Schließen'
      },
      ru: {
        close: 'Закрыть'
      }
    }
  }
}
</script>

<style scoped>

</style>
